<template>
  <v-container class="fill-height align-start pa-0" fluid>
    <v-row no-gutters>
      <v-col cols="4" class="d-flex headline px-2 align-center" justify-content="middle">
        {{$route.meta.title}}
      </v-col>
      <v-col cols="8">
        <question-header :prevent-next="preventNext" :prevent-back="preventBack"></question-header>
      </v-col>
    </v-row>
    <v-container fluid class="fill-height align-start" style="height: calc(100% - 56px)">
      <router-view></router-view>
    </v-container>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import QuestionHeader from "../components/MainContent/QuestionCreator2/QuestionHeader";

export default {
  name: "Create",

  components: {QuestionHeader},

  computed: {
    preventBack () {
      return this.$route.name === 'create'
    },
    preventNext() {
      if (this.$route.name === 'startPoint' && !this.question.startpoint) {
        return true
      }
      if (this.$route.name === 'endPoint' && !this.question.endpoint) {
        return true
      }
      if (this.$route.name === 'routes' && !this.question.routes.length) {
        return true
      }
    },
    question() {
      return this.$store.getters.getNewQuestion
    },
  },

  data() {
    return {}
  }
}
</script>

<style scoped>

</style>
